export default __webpack_public_path__ + "static/winter-bush-6ae453124c3639ef43a858a798f6f43b.png";